import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import ArrowCircleIcon from "../../../../../assets/svgIcons/ArrowCircleIcon";
import { defaultDateDisplay, formatCurrency } from "../../../../../helpers";
import primaryComponents from "../../../../primaryComponents";
import styles from "../CardListener/styles.module.scss";

export const TransferLinkConfirmation = ({
  transactionDetails,
  isLoading,
  proceed = () => {},
}) => {
  return (
    <div className={globalStyles.pageColumnGaps}>
      <p>
        Are you sure you want to confirm this transaction? This action cannot be
        reversed.
      </p>

      <div className={`${globalStyles.cardWithBackground} ${styles.tnxCard}`}>
        <div>
          <h5 className="mb-0">{transactionDetails?.payer}</h5>

          <p className="dark--text">
            <span className="gray--text">Tnx ID:</span> {transactionDetails?.id}{" "}
            | {transactionDetails?.payer_bank || "N/A"}
          </p>
        </div>

        <div className="text-right">
          <h5 className="success--text mb-0">
            {formatCurrency({ value: transactionDetails?.amount })}
          </h5>
          <p className="smallest-text-size">
            {defaultDateDisplay(transactionDetails?.created_at)}
          </p>
        </div>
      </div>

      <primaryComponents.Button
        classNames={"btn btn--primary cover mt-4"}
        isLoading={isLoading}
        isDisabled={isLoading}
        loadingText={"Confirming..."}
        onClick={() => proceed(transactionDetails?.id)}
      >
        <ArrowCircleIcon className="mr-1" />
        Confirm
      </primaryComponents.Button>
    </div>
  );
};
